import { render } from "./MaltClassicExpertiseSide.vue?vue&type=template&id=888cdd26&ts=true"
import script from "./MaltClassicExpertiseSide.vue?vue&type=script&lang=ts"
export * from "./MaltClassicExpertiseSide.vue?vue&type=script&lang=ts"

import exportComponent from "/tmpfs/builds/maltcommunity/malt/apps/malt/node_modules/.pnpm/vue-loader@17.0.1_p6ywf2fz4v3oextcdrklqlunue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__